// extracted by mini-css-extract-plugin
module.exports = {"dateIndexDetail":"average-index_dateIndexDetail__1OF8E","validIndexWrap":"average-index_validIndexWrap__ovari","validIndexHelp":"average-index_validIndexHelp___4AwV"};